import { Stack } from '@mui/material'
import React from 'react'
import { FacebookIcon, FacebookShareButton, TelegramIcon, TelegramShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share'

const SocialShare = ({shareUrl,title}) => {
    return (
        <Stack direction={'row'} spacing={1}>
            <WhatsappShareButton
                url={shareUrl}
                quote={title}
                hashtag={'#thread'}
            >
                <WhatsappIcon size={20} round={true} />
            </WhatsappShareButton>
            <FacebookShareButton
                url={shareUrl}
                quote={title}
                hashtag={'#thread'}
            >
                <FacebookIcon size={20} round={true} />
            </FacebookShareButton>
            <TelegramShareButton
                url={shareUrl}
                quote={title}
                hashtag={'#thread'}
            >
                <TelegramIcon size={20} round={true} />
            </TelegramShareButton>
            <TwitterShareButton
                url={shareUrl}
                quote={title}
                hashtag={'#thread'}
            >
                <TwitterIcon size={20} round={true} />
            </TwitterShareButton>
        </Stack>
    )
}

export default SocialShare